import { Column } from "@tanstack/react-table";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { Icon } from "../Icon";

export const SortIndicator = <T, V>({ column }: { column: Column<T, V> }) => {
  const sortDirection = column.getIsSorted();

  if (!sortDirection) return null;

  return (
    <Icon
      display="inline-block"
      ml={1}
      size="20px"
      color="gray.40"
      Type={sortDirection === "asc" ? FaSortDown : FaSortUp}
    />
  );
};
